<template>
  <div class="conten" :style="backgroundStyle">
    <div class="top-h2">
      <div class="box-top">
        <div class="detail" @click="goAbout()">查看选手列表</div>
        <h2
          style="width: 100%; text-align: center; font-size: 30px; color: #fff"
        >
          评分结果
        </h2>
        <div class="detail" @click="goRanking()">查看排名榜</div>
      </div>
    </div>
    <div class="box">
      <!-- <div style="height: 100%;"> -->
      <div class="player-card" style="width: 8vw; height: 25vh">
        <div class="avatar">
          <el-image
            :src="'https://qiniu.hnzsnetwork.cn/' + currentData.userimg"
            fit="fill"
          >
            <template slot="error">
              <el-image
                src="https://pfhd.hnzsnetwork.cn/static/images/screen/livemark/default.png"
                fit="fill"
              />
            </template>
          </el-image>
        </div>
        <div class="player-info">
          {{ currentData.username }}
        </div>
      </div>
      <div class="footer">
        <div class="footer-container">
          <div class="footer-title">
            <div style="margin-left: 20px">最终得分</div>
            <div class="display">
              <div class="number">{{ currentData.score }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import { getconfiglivemarkList } from "@/utils/http.js";
export default {
  data() {
    return {
      currentData: {},
      huodongId: this.$route.query.huodongId,
      bgimg: "", //背景图片
      baseurl: "https://xileqiniuzdy.hnzsnetwork.cn/",
    };
  },
  created() {
    const data = JSON.parse(localStorage.getItem("huodongData"));
    this.currentData = data.find((item) => {
      if (Number(item.id) === Number(this.$route.query.id)) return item;
    });
    console.log("this.currentData", this.currentData);
    getconfiglivemarkList({ huodongId: this.huodongId }).then((res) => {
      this.bgimg = this.baseurl + res.rows[0].bgimg;
    });
  },
  computed: {
    backgroundStyle() {
      console.log("this.bgimg", this.bgimg);
      return {
        backgroundImage: `url(${this.bgimg})`,
        // 其他样式
      };
    },
  },
  methods: {
    goAbout() {
      this.$router.push({
        name: "About",
        query: { huodongId: this.$route.query.huodongId },
      });
    },
    goRanking() {
      this.$router.push({
        name: "Ranking",
        query: { huodongId: this.$route.query.huodongId },
      });
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep .el-switch {
  width: 80px;
}

::v-deep .el-switch__label {
  position: absolute;
  display: none;
  color: #fff;
}

/*打开时文字位置设置*/
::v-deep .el-switch__label--right {
  z-index: 1;
  right: 40px;
}

/*关闭时文字位置设置*/
::v-deep .el-switch__label--left {
  z-index: 1;
  left: 40px;
}

/*显示文字*/
::v-deep .el-switch__label.is-active {
  display: block;
}

::v-deep .el-switch .el-switch__core {
  width: 60px !important;
}

::v-deep .el-switch .el-switch__core,
.el-switch .el-switch__label {
  width: 55px;
}

.top-h2 {
  display: flex;
  justify-items: center;
  align-items: center;
  width: 100%;
  height: 25%;
}

.conten {
  width: 100%;
  height: 100%;
  // background-image: url(https://qiniu.hnzsnetwork.cn/attachment/web/images/0/2023/11/ah3ujK83SlERaNiIeycbjwGSdXSlAXCD.jpg);
  background-size: 100% 100%;
}

.box {
  width: 57%;
  height: 71%;
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  border: 1px solid transparent;
}

.box-top {
  display: flex;
  align-items: flex-end;
  height: 50px;
  width: 100%;
  justify-content: space-between;
  padding-left: 65px;
  padding-right: 50px;
  margin: 0 auto;

  .detail {
    color: #fff;
    border: 1px solid #fff;
    text-align: center;
    width: 180px;
    height: 25px;
    line-height: 25px;
    text-align: center;
    border-radius: 17px;
    cursor: pointer;
  }
}

.content {
  display: grid;
  flex-wrap: wrap;
  justify-content: center;
  width: 102%;
  margin-top: 81px;

  .image {
    border-radius: 5px;
    margin: 0 auto;

    background-size: 100% 100%;
  }
}

body::-webkit-scrollbar {
  display: none;
}

.footer {
  display: flex;
  justify-content: center;

  .footer-container {
    display: flex;
    margin: 0 auto;
    height: 10%;

    .footer-title {
      color: #fff;
      font-size: 18px;

      .display {
        display: flex;
        margin-top: 5px;

        .number {
          width: 98px;
          height: 20px;
          text-align: center;
          color: #fff;
          /* margin: 0 auto; */
          margin-left: 8px;
          line-height: 20px;
          border: 1px solid #fff;
        }

        .number-title {
          color: #fff;
        }
      }

      .mntitle {
        // color: rgb(255, 166, 0);
        color: rgb(109, 53, 138);
        margin-left: 32px;
      }
    }
  }
}

//-----------------
// .box {
//   display: flex;
//   justify-content: center;
//   align-content: center;
//   flex-direction: column;
// }

.player-card {
  margin: 10px auto;
  margin-top: 8%;
  margin-bottom: 20px;
}
</style>
